import React from "react";
import { Result } from "antd";
import { Link } from "react-router-dom";
import {
  BACK_HOME,
  NOT_FOUND_STATUS,
  NOT_FOUND_SUB_TITLE,
  NOT_FOUND_TITLE,
} from "../../constants/pages";
import { HOMEPAGE_PATH } from "../../constants/auth";

const NotFoundPage: React.FC = () => (
  <Result
    status={NOT_FOUND_STATUS}
    title={NOT_FOUND_TITLE}
    subTitle={NOT_FOUND_SUB_TITLE}
    extra={
      <Link to={HOMEPAGE_PATH} className="ant-btn ant-btn-primary">
        {BACK_HOME}
      </Link>
    }
  />
);

export default NotFoundPage;
